/**
 * Initialize facets
 */

import { isNullOrWhiteSpace } from "../utils";
import SearchParams from "./SearchParams";
import _ from 'lodash';
import { presetFilterServices } from "./utils";
import { updateCssClassFilters } from "./utils";

(function (klevu) {

	function getValueByParam(key, current, filterUnSeleted, singleSelect) {
		if (singleSelect == 'true') {
			return current;
		}
		const urlParameter = klevu.getUrlParameter(key);
		const values = urlParameter ? decodeURIComponent(urlParameter).split(',') : [];

		return _.remove(_.union(values, current), (value) => {
			return !(filterUnSeleted.key && filterUnSeleted.value && key == filterUnSeleted.key && value == filterUnSeleted.value);
		});
	}

	/**
	 * Function to attach event on facet items
	 * @param {*} scope
	 */
	function attachFacetItemsClickEvent(scope) {
		var target = klevu.getSetting(scope.settings, "settings.search.searchBoxTarget");
		klevu.each(klevu.dom.find(".klevuFilterOption", target), function (key, value) {
			klevu.event.attach(value, "click", function (event) {
				const cssCustomAndQuery = "isCustomAndQuery";
				const customAndQuerySelected = this.classList.contains(cssCustomAndQuery);
				var $landing = document.querySelector('.klevuResultsListingBlock');
				if ($landing) {
					var searchStartEvent = new CustomEvent('klevuResultsListingBlock.search.start');
					$landing.dispatchEvent(searchStartEvent);
				}

				event = event || window.event;
				event.preventDefault();

				var parentElem = klevu.dom.helpers.getClosest(this, ".klevuFilter");
				const clearAll = () => {
					var listSingleSelect = klevu.dom.find(".klevuFilterOptionActive, .customAndQuerySelected", parentElem);
					klevu.each(listSingleSelect, function (key, value) {
						value.classList.remove("klevuFilterOptionActive");
						value.classList.remove(cssCustomAndQuery);
					});
				};

				if (parentElem !== null && (parentElem.dataset.singleselect === 'true') && !this.classList.contains("klevuFilterOptionActive")) {
					clearAll();
				}

				if (this.classList.contains("klevuFilterOptionClear")) {
					clearAll();
				} else {
					this.classList.toggle("klevuFilterOptionActive");
					this.classList.remove(cssCustomAndQuery);
				}

				//getScope
				var target = klevu.dom.helpers.getClosest(this, ".klevuTarget");
				if (target === null) {
					return;
				}

				var elScope = target.kElem;
				elScope.kScope.data = elScope.kObject.resetData(elScope.kElem);
				elScope.kScope.data.context.keyCode = 0;
				elScope.kScope.data.context.eventObject = event;
				elScope.kScope.data.context.event = "keyUp";
				elScope.kScope.data.context.preventDefault = false;

				//override local variables

				var options = klevu.dom.helpers.getClosest(this, ".klevuMeta");
				if (options === null) {
					return;
				}
				//calculate new filters
				//getAllActiveFilters
				const filter = klevu.dom.helpers.getClosest(value, ".klevuFilter");
				const filterSelected = this.classList.contains("klevuFilterOptionActive");
				const filterUnSeleted = filterSelected || customAndQuerySelected ? {} : {
					key: filter.dataset.filter,
					value: value.dataset.value,
				};
				filter.dataset.filter !== 'type' && presetFilterServices().delete(filter.dataset.filter);
				const listActive = klevu.dom.find(".klevuFilterOptionActive", options);

				updateCssClassFilters(filter.dataset.filter);

				if (listActive.length > 0) {
					const filterList = [];
					klevu.each(listActive, function (key, filterElement) {
						const filter = klevu.dom.helpers.getClosest(filterElement, ".klevuFilter");

						if (filter !== null) {
							const objectToChange = filterList.find((element) => element.key == filter.dataset.filter);
							const singleSelect = klevu.isUndefined(filter.dataset.singleselect) ? false : filter.dataset.singleselect;
							const filterValue = isNullOrWhiteSpace(filterElement.querySelector('.kufacet-value').textContent) ? false: filterElement.querySelector('.kufacet-value').textContent;
							const filterKey = filter.dataset.filter;

							if (objectToChange) {
								objectToChange.values = getValueByParam(
									filterKey,
									[filterValue].concat(objectToChange.values),
									filterUnSeleted,
									singleSelect
								);
							} else {
								filterList.push({
									key: filterKey,
									settings: {
										singleSelect,
									},
									values: getValueByParam(
										filterKey,
										[filterValue],
										filterUnSeleted,
										singleSelect,
									),
								});
							}
						}
					});
					klevu.setObjectPath(elScope.kScope.data, "localOverrides.query." + options.dataset.section + ".filters.applyFilters.filters", filterList);
				} else {
					klevu.setObjectPath(elScope.kScope.data, "localOverrides.query." + options.dataset.section + ".filters.applyFilters", {});
				}

				const KLEVU_PRICE = 'klevu_price';
				const searchParams = new SearchParams();

				if (searchParams.has(KLEVU_PRICE)) {
					var localQuery = elScope.data.localOverrides.query['productList'];

					var sliderFilterReqObj = {
						key: KLEVU_PRICE,
						settings: {
							singleSelect: "false"
						},
						values: searchParams.get(KLEVU_PRICE).split(',')
					};

					if (!localQuery.filters) {
						localQuery.filters = {
							applyFilters: {
								filters: [sliderFilterReqObj]
							}
						};
					} else {
						var applyFilters = localQuery.filters.applyFilters.filters;
						var isUpdated = false;
						if (applyFilters) {
							applyFilters.forEach(function (filter) {
								if (filter.key == KLEVU_PRICE) {
									isUpdated = true;
									filter.values = sliderFilterReqObj.values
								}
							});
							if (!isUpdated) {
								applyFilters.push(sliderFilterReqObj);
							}
						} else {
							applyFilters = [sliderFilterReqObj];
						}
						klevu.setObjectPath(elScope.kScope.data, "localOverrides.query." + options.dataset.section + ".filters.applyFilters.filters", applyFilters);
					}
				}

				searchParams.paginate(1).pushState();

				//reset offset after filter change
				klevu.setObjectPath(elScope.kScope.data, "localOverrides.query." + options.dataset.section + ".settings.offset", 0);
				klevu.event.fireChain(elScope.kScope, "chains.events.keyUp", elScope, elScope.kScope.data, event);
			}, true);
		});
	}

	var facets = {
		attachFacetItemsClickEvent: attachFacetItemsClickEvent
	};

	klevu.extend(true, klevu.search.modules, {
		facets: {
			base: facets,
			build: true
		}
	});

})(klevu);

/**
 * facets module build event
 */
klevu.coreEvent.build({
	name: "facetsModuleBuild",
	fire: function () {
		if (!klevu.search.modules ||
			!klevu.search.modules.facets ||
			!klevu.search.modules.facets.build) {
			return false;
		}
		return true;
	},
	maxCount: 500,
	delay: 30
});



// WEBPACK FOOTER //
// ./klevu/klevu-facets.js